import { useMutation } from '@tanstack/react-query';

import type { ExportCsvResponse } from '@/types/api/mutations';
import type { ServiceUsageHistoryAnalyticsFilters } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const useExportServiceUsageHistoryAnalyticsCsvMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      filters: ServiceUsageHistoryAnalyticsFilters;
    }) =>
      HttpClient.request<ExportCsvResponse>({
        method: 'POST',
        url: params.url,
        data: { filters: params.filters },
      }),
  });
